import { DailyCheckInCampaign } from '@apeiron/reward'
import { deserializeListData } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { dailyCheckInCampaignSchema } from '@src/deserialize/yup/reward'
import graphql from '@src/graphql/query/getMyDailyCheckInCampaigns'
import { useCallback, useState } from 'react'

const useGetMyDailyCheckInCampaigns = (): Hook => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<DailyCheckInCampaign[]>([])

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { campaignTypes = [] } = request

      const response = await query({
        variables: {
          input: {
            campaignTypes
          }
        }
      })

      const dailyShop = deserializeListData<DailyCheckInCampaign>(
        response,
        dailyCheckInCampaignSchema
      )

      setData(dailyShop)

      return {
        data: dailyShop
      }
    },
    [query]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Request = {
  campaignTypes: string[]
}

type Response = {
  data: DailyCheckInCampaign[]
}

type Hook = {
  data: DailyCheckInCampaign[]
  fetch: (request: Request) => Promise<Response>
  loading: boolean
}

export default useGetMyDailyCheckInCampaigns
